import { ViewEdiBilling } from "@mcleod/datafusion/src/ViewEdiBilling";
import { Button, DataSource, DataSourceMode, Layout, SaveAction, SaveButton, SlideoutDecorator, Tab, Toast, Snackbar } from "@mcleod/components";
import { HorizontalAlignment, Api } from "@mcleod/core";
import { ViewEdiBalanceDue } from "./ViewEdiBalanceDue";
import { CommonDialogs } from "@mcleod/common";
import { LMEUserSettings } from "@mcleod/general";


interface EdiBillingProps {
    sourceEdiBilling: DataSource;
    tabErrorsVisible: boolean;
    sourceEdiBillingMode: DataSourceMode;
    textReadyToSendEnabled: boolean;
    txtCorrectionIndicatorEnabled: boolean;
    txtServiceCodeEnabled: boolean;
    txtBatchEnabled: boolean;
    switchTransmitEnabled: boolean;
}
export const saveButton = SaveButton.create({
    rowBreak: false,
    caption: "Save & Close",
    align: HorizontalAlignment.RIGHT,
    color: "McLeodWhite",
    id: "buttonSave"
});
export function openEdiBillingSlideout(props: EdiBillingProps) {
    const { sourceEdiBilling, tabErrorsVisible, sourceEdiBillingMode, textReadyToSendEnabled, txtCorrectionIndicatorEnabled, txtServiceCodeEnabled, txtBatchEnabled, switchTransmitEnabled } = props;
    const viewEdiBilling = Layout.getLayout("lme/datafusion/ViewEdiBilling") as ViewEdiBilling;

    saveButton.onSave = async (row) => {
        await viewEdiBilling.onSave()
    }
    new SlideoutDecorator({
        layout: viewEdiBilling,
        title: "DataFusion Invoice",
        fillVerticalSpace: true,
        width: 850,
        addlComponents: saveButton,
        layoutLoadListeners: (async () => {
            saveButton.dataSource = viewEdiBilling.sourceEdiBilling;
        }),
        doAfterSlideIn: async (decorator: SlideoutDecorator) => {
            await viewEdiBilling.sourceEdiBilling.search({ id: sourceEdiBilling.activeRow.get("id") });
            viewEdiBilling.tabErrors.visible = tabErrorsVisible;
            viewEdiBilling.sourceEdiBilling.mode = sourceEdiBillingMode;
            viewEdiBilling.textReadyToSend.enabled = textReadyToSendEnabled;
            viewEdiBilling.txtCorrectionIndicator.enabled = txtCorrectionIndicatorEnabled;
            viewEdiBilling.txtServiceCode.enabled = txtServiceCodeEnabled;
            viewEdiBilling.txtBatch.enabled = txtBatchEnabled;
            viewEdiBilling.panelFuncAck.visible = false;
            viewEdiBilling.labelEditWarning.visible = true;
            viewEdiBilling.switchTransmit.visible = switchTransmitEnabled;
            viewEdiBilling.switchTransmit.enabled = switchTransmitEnabled;
            viewEdiBilling.txtShipmentId.visible = true;
            viewEdiBilling.textboxBlnum.visible = true;
            viewEdiBilling.textboxConsigneeRefNo.visible = true;
            viewEdiBilling.textboxCommodity.visible = true;
            viewEdiBilling.textboxCommodityDescr.visible = true;
            viewEdiBilling.textboxWeight.visible = true;
            viewEdiBilling.textboxPieces.visible = true;
            viewEdiBilling.openedFromSlideout = true;
        },
        doAfterSlideOut: async () => {
            await sourceEdiBilling.search({ id: sourceEdiBilling.activeRow.get("id") });
            if (viewEdiBilling.newBatch > 0) {
                Toast.showSuccessToast("Batch " + viewEdiBilling.newBatch + " successfully transmitted.");
            }
        }
    });
}
interface ViewEdiBalanceDueProps {
    tabErrorsVisible: boolean;
    sourceEdiBillingMode: DataSourceMode;
    textReadyToSendEnabled: boolean;
    txtCorrectionIndicatorEnabled: boolean;
    txtServiceCodeEnabled: boolean;
    checkBalanceDueEnabled: boolean;
    txtBatchEnabled: boolean;
    billingId: string;
    mainDataSource: DataSource;
    tabBalanceDueExpanded: boolean;
    switchTransmitEnabled: boolean;
    ratesEnabled: boolean;
    ocEnabled: boolean;
}
export function openEdiBalanceDueSlideout(props: ViewEdiBalanceDueProps) {
    const { tabErrorsVisible,
        sourceEdiBillingMode,
        textReadyToSendEnabled,
        txtCorrectionIndicatorEnabled,
        txtServiceCodeEnabled,
        checkBalanceDueEnabled,
        txtBatchEnabled,
        billingId,
        mainDataSource,
        tabBalanceDueExpanded,
        switchTransmitEnabled,
        ratesEnabled,
        ocEnabled } = props;
    const viewEdiBalanceDue = Layout.getLayout("lme/datafusion/ViewEdiBalanceDue") as ViewEdiBalanceDue;
    viewEdiBalanceDue.openedFromSlideout = true;

    saveButton.onSave = async (row) => {
        await viewEdiBalanceDue.onSave()
    };
    new SlideoutDecorator({
        layout: viewEdiBalanceDue,
        title: "DataFusion Balance Due",
        fillVerticalSpace: true,
        width: 1500,
        addlComponents: saveButton,
        layoutLoadListeners: (async () => {
            saveButton.dataSource = viewEdiBalanceDue.sourceEdiBilling;
        }),
        doAfterSlideIn: async (decorator: SlideoutDecorator) => {
            await viewEdiBalanceDue.sourceEdiBilling.search({ id: billingId });
            viewEdiBalanceDue.tabErrors.visible = tabErrorsVisible;
            viewEdiBalanceDue.sourceEdiBilling.mode = sourceEdiBillingMode;
            viewEdiBalanceDue.textReadyToSend.enabled = textReadyToSendEnabled;
            viewEdiBalanceDue.txtCorrectionIndicator.enabled = txtCorrectionIndicatorEnabled;
            viewEdiBalanceDue.txtServiceCode.enabled = txtServiceCodeEnabled;
            viewEdiBalanceDue.checkBalanceDue.enabled = checkBalanceDueEnabled;
            viewEdiBalanceDue.txtBatch.enabled = txtBatchEnabled;
            await viewEdiBalanceDue.loadOtherCharges(billingId);
            viewEdiBalanceDue.buttonEdit.visible = false;
            viewEdiBalanceDue.buttonReload.visible = false;
            viewEdiBalanceDue.buttonRawData.visible = false;
            viewEdiBalanceDue.panelFuncAck.visible = false;
            viewEdiBalanceDue.switchTransmit.visible = switchTransmitEnabled;
            viewEdiBalanceDue.switchTransmit.enabled = switchTransmitEnabled;
            viewEdiBalanceDue.txtShipmentId.visible = true;
            viewEdiBalanceDue.textboxBlnum.visible = true;
            viewEdiBalanceDue.textboxConsigneeRefNo.visible = true;
            viewEdiBalanceDue.textboxCommodity.visible = true;
            viewEdiBalanceDue.textboxCommodityDescr.visible = true;
            viewEdiBalanceDue.textboxWeight.visible = true;
            viewEdiBalanceDue.textboxPieces.visible = true;
            viewEdiBalanceDue.panelRates.visible = ratesEnabled;
            viewEdiBalanceDue.panelAdditionalCharges.visible = ocEnabled;
            viewEdiBalanceDue.labelEditWarning.visible = true;
            await viewEdiBalanceDue.loadTaxCharges(billingId);
        },
        doAfterSlideOut: async () => {
            await mainDataSource.search({ id: billingId });
            if (viewEdiBalanceDue.newBatch > 0) {
                Toast.showSuccessToast("Batch " + viewEdiBalanceDue.newBatch + " successfully transmitted.");
            }
        }
    });
}

/**
 * Handles the API call to reload EDI billing and processes the response
 */
async function handleReloadApiCall(ediBillingDataSource: DataSource, ID: string, resetBatch: boolean): Promise<void> {
    const response = await Api.post("lme/datafusion/reload-edi-bill", {
        edi_billing_id: ID,
        user_id: LMEUserSettings.getUserId(),
        reset_batch: resetBatch
    });

    if (response.data.length > 0 && response.data[0].error) {
        Snackbar.showWarningSnackbar(response.data[0].error);
    } else if (ediBillingDataSource.activeRow) {
        await ediBillingDataSource.search({ id: ID });

        // Check for additional charge warnings
        if (response.data.length > 0) {
            if (response.data[0]?.no_added_oc) {
                Snackbar.showWarningSnackbar("Some Additional Charges were not added, since the Bill-to does not match");
            }
            if (response.data[0]?.no_added_et) {
                Snackbar.showWarningSnackbar("Some Tax Charges were not added, since the Bill-to does not match");
            }
        }
    }
}

/**
 * Reloads an EDI billing record, handling batch number confirmation if necessary
 * @param ediBillingDataSource - The DataSource containing the EDI billing record
 */
export async function reloadEdiBilling(ediBillingDataSource: DataSource): Promise<void> {
    const ID = ediBillingDataSource.activeRow?.get("id");
    if (!ID) {
        return;
    }

    const batchNumber = ediBillingDataSource.activeRow?.get("batch");

    if (batchNumber > 0) {
        const result = await CommonDialogs.showYesNo(
            "Cannot update DataFusion invoice record with a batch number greater than 0. Do you want to reset the batch number to 0? This will result in the current record being retransmitted with a new batch number.",
            "Batch Number Greater Than 0"
        );

        if (result) {
            await handleReloadApiCall(ediBillingDataSource, ID, true);
        }
    } else {
        await handleReloadApiCall(ediBillingDataSource, ID, false);
    }
}
